import PrintOnEnum from './PrintOn.enum';

export default Object.freeze([
	{
		label: 'NetStamps® Sheets',
		value: PrintOnEnum.NetStamps,
		tooltip:
			'<strong>NetStamps Labels</strong><br>Use NetStamps labels when all you need is postage. They work just like regular ' +
			'stamps with no date or address restrictions and can be used when sending First-Class ' +
			'Mail postcards, envelopes, and large envelopes to any U.S. or international destination.',
	},
	{
		label: 'Shipping Label - 8 ½" x 11" Paper',
		value: PrintOnEnum.ShippingLabel812x11,
		tooltip:
			'<strong>8 &frac12;&rdquo; x 11&rdquo; Paper</strong><br>Use any letter-size sheet of plain paper to print up to two 4&rdquo; x 6&rdquo; ' +
			'shipping labels, including addresses, tracking barcode, and customs form.' +
			'<br><br>Can be used to ship Large Envelopes, Packages, USPS Flat Rate Envelopes or Boxes, or ' +
			'USPS Regional Rate Boxes to any U.S. or international destination.',
	},
	{
		label: 'Shipping Label - SDC-1200, 4 ¼" x 6 ¾"',
		value: PrintOnEnum.ShippingLabel1200,
		tooltip:
			'<strong>4 &frac14;&rdquo; x 6 &frac34;&rdquo; Shipping Label</strong><br>Use these letter-sized label sheets with two 4 &frac14;&rdquo; x 6 &frac34;&rdquo; labels per sheet ' +
			'to print addresses, tracking barcode, and customs form.<br><br>' +
			'Can be used to ship Large Envelopes, Packages, USPS Flat Rate Envelopes or ' +
			'Boxes, or USPS Regional Rate Boxes to any U.S. or international destination.',
	},
	{
		label: 'Shipping Label - 5 ½" x 8 ½"',
		value: PrintOnEnum.ShippingLabel512x812,
		tooltip:
			'<strong>5 &frac12;&rdquo; x 8 &frac12;&rdquo; Shipping Label</strong><br>Use these letter-sized label sheets with two 5 &frac12;&rdquo; x 8 &frac12;&rdquo; labels per sheet ' +
			'to print addresses, tracking barcode, and customs form.<br><br>' +
			'Can be used to ship Large Envelopes, Packages, USPS Flat Rate Envelopes or Boxes, or USPS Regional Rate Boxes to any U.S. destination.<br><br>' +
			'Product Numbers:<br>Avery 5126, 8126, 5526, 5783, 15516, 18126, 85783',
	},
	{
		label: 'Envelope - #10, 4 ⅛" x 9 ½"',
		value: PrintOnEnum.Envelope10,
		tooltip:
			'<strong>#10 Envelope</strong><br>Print First-Class postage, delivery address, and/or return address directly onto any standard #10 envelope.',
	},
	{
		label: 'Envelope - #9, 3 ⅞" x 8 ⅞"',
		value: PrintOnEnum.Envelope9,
		tooltip:
			'<strong>#9 Envelope</strong><br>Print First-Class postage, delivery address, and/or return address directly onto any standard #9 envelope.',
	},
	{
		label: 'Envelope - #A9, 5 ¾" x 8 ¾"',
		value: PrintOnEnum.EnvelopeA9,
		tooltip:
			'<strong>#A9 Envelope</strong><br>Print First-Class postage, delivery address, and/or return address directly onto any standard #A9 envelope.',
	},
	{
		label: 'Envelope - #6, 3 ⅝" x 6 ½"',
		value: PrintOnEnum.Envelope6,
		tooltip:
			'<strong>#6 Envelope</strong><br>Print First-Class postage, delivery address, and/or return address directly onto any standard #6 envelope.',
	},
	{
		label: 'Envelope - #A2, 4 ⅜" x 5 ¾"',
		value: PrintOnEnum.EnvelopeA2,
		tooltip:
			'<strong>#A2 Envelope</strong><br>Print First-Class postage, delivery address, and/or return address directly onto any standard #A2 envelope.',
	},
	{
		label: 'Envelope - #7, 3 ⅞" x 7 ½"',
		value: PrintOnEnum.Envelope7,
		tooltip:
			'<strong>#7 Envelope</strong><br>Print First-Class postage, delivery address, and/or return address directly onto any standard #7 envelope.',
	},
	{
		label: 'Envelope - #11, 4 ½" x 10 ⅜"',
		value: PrintOnEnum.Envelope11,
		tooltip:
			'<strong>#11 Envelope</strong><br>Print First-Class postage, delivery address, and/or return address directly onto any standard #11 envelope.',
	},
	{
		label: 'Envelope - #12, 4 ¾" x 11"',
		value: PrintOnEnum.Envelope12,
		tooltip:
			'<strong>#12 Envelope</strong><br>Print First-Class postage, delivery address, and/or return address directly onto any standard #12 envelope.',
	},
	{
		label: 'Certified Mail Label - SDC-3610',
		value: PrintOnEnum.MailingLabelCM3610,
		tooltip:
			'<strong>SDC-3610 Certified Mail Label</strong><br>Print postage, delivery address, return address, and Certified Mail tracking ' +
			'number onto these SDC-3610 Certified Mail labels. Additional Certified Mail ' +
			'options include Electronic Return Receipt and Restricted Delivery.<br><br>' +
			'Can be used when mailing First-Class or Priority Mail envelopes, large ' +
			'envelopes or packages to any U.S. destination.',
	},
	{
		label: 'Certified Mail Label - SDC-3710',
		value: PrintOnEnum.MailingLabelCM3710,
		tooltip:
			'<strong>SDC-3710 Certified Mail Label</strong><br>Print postage, delivery address, return address, and Certified Mail ' +
			'tracking number onto these SDC-3710 Certified Mail labels. Additional ' +
			'Certified Mail options include Electronic Return Receipt, Restricted ' +
			'Delivery, and Proof of Mail Receipt.<br><br>Can be used when mailing ' +
			'First-Class or Priority Mail envelopes, large envelopes or packages to ' +
			'any U.S. destination.',
	},
	{
		label: 'Certified Mail Label - SDC-3910',
		value: PrintOnEnum.MailingLabelCM3910,
		tooltip:
			'<strong>SDC-3910 Certified Mail Label</strong><br>Print postage, delivery address, return address, and Certified Mail ' +
			'tracking number onto these SDC-3910 Certified Mail labels. Additional ' +
			'Certified Mail options include Return Receipt, Electronic Return Receipt, ' +
			'Restricted Delivery, and Proof of Mail Receipt.<br><br>Can be used when ' +
			'mailing First-Class or Priority Mail envelopes, large envelopes or packages ' +
			'to any U.S. destination.',
	},
	{
		label: 'Certified Mail Label - SDC-3930',
		value: PrintOnEnum.MailingLabelCM3930,
		tooltip:
			'<strong>SDC-3930 Certified Mail Label</strong><br>Print postage, delivery address, return address, and Certified Mail ' +
			'tracking number onto these SDC-3930 Certified Mail labels. Additional ' +
			'Certified Mail options include Return Receipt, Electronic Return Receipt, ' +
			'Restricted Delivery, and Proof of Mail Receipt.<br><br>Can be used when ' +
			'mailing First-Class or Priority Mail envelopes, large envelopes or packages ' +
			'to any U.S. destination.',
	},
	{
		label: 'Certified Mail #10 Window Envelope - SDC-3510',
		value: PrintOnEnum.EnvelopeCM3510,
		tooltip:
			'<strong>#10 Certified Mail Window Envelope for Electronic Return Receipt</strong><br>' +
			'Print all the required information and barcodes on one simple sheet of paper, and then slip it into ' +
			'our #10 Certified Mail Envelope. Certified Mail tracking number is recorded by Stamps.com so ' +
			'you can view all tracking events including delivery.<br><br>' +
			'Can be used to mail First-Class envelopes to any U.S. destination.',
	},
	{
		label: 'Certified Mail Window Envelope 6" x 9" - SDC-3520',
		value: PrintOnEnum.EnvelopeCM3520,
		tooltip:
			'<strong>6" x 9" Certified Mail Window Envelopes for Electronic Return Receipt</strong><br>' +
			'Print all the required information and barcodes on one simple sheet of paper, and then slip it into ' +
			'our 6" x 9" Certified Mail Envelope. Certified Mail tracking number is recorded by Stamps.com ' +
			'so you can view all tracking events including delivery.<br><br>' +
			'Can be used to mail First-Class envelopes to any U.S. destination.',
	},
	{
		label: 'Certified Mail Window Envelope 9" x 12" - SDC-3530',
		value: PrintOnEnum.EnvelopeCM3530,
		tooltip:
			'<strong>9" x 12" Certified Mail Window Envelopes for Electronic Return Receipt</strong><br>' +
			'Print all the required information and barcodes on one simple sheet of paper, and then slip it into ' +
			'our 9" x 12" Certified Mail Envelope. Certified Mail tracking number is recorded by Stamps.com ' +
			'so you can view all tracking events including delivery.<br><br>' +
			'Can be used to mail First-Class Large Envelopes to any U.S. destination.',
	},
	{
		label: 'Certified Mail #11 Envelope - SDC-3810',
		value: PrintOnEnum.EnvelopeCM3810,
		tooltip:
			'<strong>#11 Certified Mail Envelope</strong><br>Print postage, delivery address, return address, Certified Mail ' +
			'tracking number, and physical return receipt directly onto these #11 ' +
			'Certified Mail Envelopes.<br><br>Can be used to mail First-Class or ' +
			'Priority Mail envelopes to any U.S. destination.',
	},
	{
		label: 'Certified Mail #10 Envelope - SDC-3820',
		value: PrintOnEnum.EnvelopeCM3820,
		tooltip:
			'<strong>#10 Certified Mail Envelope</strong><br>' +
			'Print postage, delivery address, return address, and Certified  ' +
			'Mail tracking number directly onto these #10 Certified Mail Envelopes  ' +
			'for Electronic Return Receipt.<br><br>' +
			'Can be used to mail First-Class envelopes to any U.S. destination.',
	},
	{
		label: 'Certified Mail #11 Envelope - SDC-3830',
		value: PrintOnEnum.EnvelopeCM3830,
		tooltip:
			'<strong>#11 Certified Mail Envelope</strong><br>Print postage, delivery address, return address, Certified Mail ' +
			'tracking number, and physical return receipt directly onto these #11 ' +
			'Certified Mail Envelopes.<br><br>Can be used to mail First-Class or ' +
			'Priority Mail envelopes to any U.S. destination.',
	},
	{
		label: 'Label - SDC-3110 - Multi-Purpose (3-Part)',
		value: PrintOnEnum.MailingLabelSDC3110,
		tooltip:
			'<strong>SDC-3110 - 3-Part Multi-Purpose</strong><br>Print postage, delivery address, and return address ' +
			'onto these SDC-3110 3-Part Multi-Purpose labels. <br><br>' +
			'Can be used when mailing First-Class envelopes to any U.S. destination.',
	},
	{
		label: 'Label - SDC-5030 - 1" x 2 5/8" (2-part)',
		value: PrintOnEnum.MailingLabelSDC5030,
		tooltip:
			'<strong>SDC-5030 - Multi-Purpose Label</strong><br>Print postage and delivery addresses onto these SDC-5030 Multi-Purpose labels. Each sheet ' +
			'prints 15 labels, with 2 stickers required per label.' +
			'<br><br>Can be used when mailing First-Class envelopes to any U.S. destination.',
	},
	{
		label: 'Label - SDC-2200 - Multi-Purpose (2-Part)',
		value: PrintOnEnum.MailingLabelSDC2200,
		tooltip:
			'<strong>SDC-2200 - 2-Part Multi-Purpose</strong><br>Print postage and delivery address ' +
			'onto these SDC-2200 2-Part Multi-Purpose labels. <br><br>' +
			'Can be used when mailing First-Class envelopes to any U.S. destination.',
	},
	{
		label: 'Roll - 4" x 6" Shipping Label',
		value: PrintOnEnum.Roll4x6,
		tooltip:
			'<strong>4&rdquo; x 6&rdquo; Shipping Label Roll</strong><br>Use these 4&rdquo; x 6&rdquo; thermal label rolls to print addresses, ' +
			'tracking barcode, and customs form.<br><br>Can be used to ship any mailpiece ' +
			'to any U.S. or international destination.<br><br>Compatible Printers:<br>' +
			'Most Zebra/Eltron models and Samsung Bixolon SRP 770II.',
	},
	{
		label: 'Roll - 4 ⅛" x 6 ¼" Shipping Label',
		value: PrintOnEnum.Roll418x614,
		tooltip:
			'<strong>4 &#8539;&rdquo; x 6 &#188;&rdquo; Shipping Label Roll</strong><br>Use these 4&#8539;&rdquo; x 6&frac14;&rdquo; thermal label rolls to print addresses, ' +
			'tracking barcode, and customs form.<br><br>Can be used to ship Large Envelopes, ' +
			'Packages, USPS Flat Rate Envelopes or Boxes, or USPS Regional Rate Boxes to any ' +
			'U.S. or international destination.<br><br>Compatible Printers:<br>Dymo 4XL, ' +
			'most Zebra/Eltron models and Samsung Bixolon SRP 770II.',
	},
	{
		label: 'Roll - Stamps.com Universal 2 ⅛" x 7 ½" Label',
		value: PrintOnEnum.Roll2x7,
		tooltip:
			'<strong>Stamps.com Universal 2 &#8539;&rdquo; x 7 &#189;&rdquo; Label Roll</strong><br>Use these 2 &#8539;&rdquo; x 7 &#189;&rdquo; thermal label rolls to print addresses ' +
			'and tracking barcode.<br><br>Can be used to ship packages to any U.S. destination via USPS.',
	},
]);
